import React from 'react'

import './Landing.css'

import Page from '../../Components/Page'
import Card from '../../Components/Card'




const Landing = (props) => {
    const { main, inner_main, link, center, hfter } = styles
    const {history} = props
    return (
        <Page>
            <Card>
                <div className="center">
                    <div>
                        <h1 className="title">7 miles</h1>
                    </div>
                    <button className="cy_button" onClick={()=>history.push('/challenge')}>Challenge yourself</button>
                    <div style={{ ...hfter, ...{ justifyContent: "center", color: 'gray' } }}>
                        contact us friends@7miles.app
                    </div>
                </div>
            </Card>
        </Page>
    )
}

export default Landing;

const styles = {
    main: {
        display: 'flex',
        flex: 1,
        fontSize: '24px',
        backgroundColor: '#044F1E',
        flexDirection: 'column',
        padding: '50px',
        alignItems: 'center',
        justifyContent: 'center'
    },
    link: {
        marginRight: "10px",
        color: 'gray'
    },
    // inner_main: {
    //     flex: 1,
    //     height:'100%',
    //     width: '100%',
    //     display: 'flex',
    //     borderRadius: '3px',
    //     alignItems: 'center',
    //     justifyContent:'center',
    //     flexDirection: 'column',
    // },
    hfter: {
        fontSize: '14px',
        display: 'flex',
        minHeight: '50px',
        width: '100%',
        padding: '10px',
        boxSizing: "border-box",
        backgroundColor: 'white',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "flex-end"
    }
}




// WEBPACK FOOTER //
// ./src/Pages/Landing/index.js